import { Navigate } from "react-router-dom";
// Signed-in account pages (customer side). Merge into App.js inside the <Layout> route, wrapping each
// element in <ProtectedRoute> when `protected` is true.
import React from "react";
import Messages from "@/pages/account/Messages";
import Notifications from "@/pages/account/Notifications";
import Favourites from "@/pages/account/Favourites";
import Tickets from "@/pages/account/Tickets";
import Wallet from "@/pages/account/Wallet";
import PlanDay from "@/pages/account/PlanDay";
import AccountSettings from "@/pages/account/AccountSettings";
import CreatorStudio from "@/pages/stage/CreatorStudio";
import StageMe from "@/pages/stage/StageMe";
import CreatorTools from "@/pages/stage/CreatorTools";
import AccountHub from "@/pages/account/AccountHub";
import { SharedTrip } from "@/pages/discover/Explore";
import MoneyHub, { SplitsPage, SplitPage, CollabDeal } from "@/pages/account/Money";
import { ConfirmAge } from "@/pages/account/AuthLinks";
import { Chats, Chat, AccessRequest } from "@/pages/stage/Social";
import AskFable from "@/pages/assistant/AskFable";

export const ACCOUNT_ROUTES = [
  { path: "/messages", element: <Messages />, protected: true },
  { path: "/messages/:id", element: <Messages />, protected: true },
  { path: "/notifications", element: <Notifications />, protected: true },
  { path: "/favourites", element: <Favourites />, protected: true },
  { path: "/tickets", element: <Tickets />, protected: true },
  { path: "/wallet", element: <Wallet />, protected: true },
  { path: "/plan-day", element: <PlanDay />, protected: true },
  { path: "/settings", element: <AccountSettings />, protected: true },
  { path: "/creator-studio", element: <CreatorStudio />, protected: true },
  { path: "/stage/me", element: <StageMe />, protected: true },
  { path: "/creator-tools", element: <CreatorTools />, protected: true },
  { path: "/account", element: <AccountHub />, protected: true },
  { path: "/money", element: <MoneyHub />, protected: true },
  { path: "/chats", element: <Chats />, protected: true },
  { path: "/ask", element: <AskFable />, protected: true },
  { path: "/chats/:gid", element: <Chat />, protected: true },
  { path: "/access/requests/:rid", element: <AccessRequest />, protected: true },
  { path: "/trips/shared/:token", element: <SharedTrip />, protected: true },
  { path: "/splits", element: <SplitsPage />, protected: true },
  { path: "/splits/:sid", element: <SplitPage />, protected: true },
  { path: "/collabs/deals/:id", element: <CollabDeal />, protected: true },
  { path: "/confirm-age", element: <ConfirmAge />, protected: true },
  { path: "/hq/*", element: <Navigate to="/ops" replace /> },  // Fable HQ is now Fable Ops
];
